import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import { HomeIcon } from '../../icon/solid';
import { StudioControlStyles } from '../styles';
import { Button } from '../..';
import {
  selectCameraRecording,
  selectHomeAction,
  selectIsPlayPrompter,
} from '../../../store/modules/studio/selectors';
import {
  setRestartPrompter,
  restartRecordingCamera
} from '../../../store/modules/studio/actions';
import StudioToolTip from './StudioToolTip';

const HomeAction = () => {
  const classes = StudioControlStyles();
  const isActive = useSelector(selectHomeAction);
  const dispatch = useDispatch();
  const isPlay = useSelector(selectIsPlayPrompter);
  const isRecording = useSelector(selectCameraRecording);

  const setScrollHome = useCallback((e: React.MouseEvent) => {
    if (window.requestPrompterPosition) {
      window.requestPrompterPosition(e, 0);
    }

    if(isRecording){
      dispatch(restartRecordingCamera());
    }else if (isPlay) {
      dispatch(setRestartPrompter());
    }
  }, [dispatch, isPlay, isRecording]);

  return (
    <Grid item className={classes.smallButtonContainer}>
      <StudioToolTip title="Go to the beginning of the script">
        <Button
          className={clsx(classes.button, isActive ? classes.activeButton : '')}
          onClick={setScrollHome}
          data-intercom-target="Button: Home"
        >
          <HomeIcon className={classes.icon} />
        </Button>
      </StudioToolTip>
    </Grid>
  );
};

export default HomeAction;
